import React from 'react'
import { Heading, Paragraph } from '@scentregroup/ui'
import { get } from 'lodash'
import UtilityBox from '../utility-box'
import ExternalLink from '../external-link'
import UtilityBoxItem from '../utility-box-item'
import UtilityBoxOpeningHours from '../utility-box-opening-hours'
import { parseServiceHours } from '../../helpers/parse-opening-hours'
import locationLink from '../../helpers/location-link'
import { Centre, RawOpeningHours } from '../../../types/contentful-v1'
import {
  StoreTradingSchedule,
  ParsedOpeningHour,
} from '../../helpers/parse-opening-hours/types'
import style from './index.module.scss'

interface ServiceUtilityBox {
  centre: Centre
  centreTradingHours: RawOpeningHours
  storeTradingHours?: StoreTradingSchedule
}

const openingHours = (
  centreTradingHours: RawOpeningHours,
  storeTradingHours?: StoreTradingSchedule
): ParsedOpeningHour[] => {
  if (storeTradingHours) {
    return parseServiceHours(
      get(storeTradingHours, ['tradingHours']) || [],
      centreTradingHours.timeZone
    )
  } else {
    return parseServiceHours(
      get(centreTradingHours, ['tradingHours']) || [],
      centreTradingHours.timeZone
    )
  }
}

const ServiceUtilityBox: React.FC<ServiceUtilityBox> = ({
  centre,
  centreTradingHours,
  storeTradingHours,
}): JSX.Element | null => {
  const address = centre.physicalAddress
  const address2 = `${centre.suburb} ${centre.state || ''} ${centre.postcode}`
  const externalLocationLink = locationLink({ centre })
  return (
    <UtilityBox>
      <div className={style.utilityInfoWrapper}>
        <Heading type="small" className={style.heading} key="heading">
          {`${centre.title} Concierge`}
        </Heading>
        <UtilityBoxOpeningHours
          openingHours={openingHours(centreTradingHours, storeTradingHours)}
          centreSlug={centre.slug}
          unlinkedHours={Boolean(storeTradingHours)}
        />
        <UtilityBoxItem
          icon="phone"
          classNames={{ item: style.phoneSection }}
          role="heading"
          aria-label="Phone Number"
        >
          <Paragraph type="medium">{centre.telephoneNumber}</Paragraph>
        </UtilityBoxItem>
        {address && (
          <UtilityBoxItem
            icon="location-drop-pin"
            classNames={{ item: style.addressWrapper }}
            key="item"
            role="heading"
            aria-label="Store Location"
          >
            <Paragraph type="medium">{address}</Paragraph>
            {address2 && <Paragraph type="medium">{address2}</Paragraph>}
            {externalLocationLink && (
              <Paragraph>
                <ExternalLink
                  url={externalLocationLink}
                  className={style.mapLink}
                >
                  See on map
                </ExternalLink>
              </Paragraph>
            )}
          </UtilityBoxItem>
        )}
      </div>
    </UtilityBox>
  )
}

export default ServiceUtilityBox
